import { useEffect, useRef } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
// Email suggestion dropdown component
const EmailSuggestions = ({ suggestions, onSelect, selectedIndex, inputRef }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (dropdownRef.current && selectedIndex >= 0) {
      const selectedElement = dropdownRef.current.children[selectedIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({ block: "nearest" });
      }
    }
  }, [selectedIndex]);

  if (suggestions.length === 0) return null;

  return (
    <div
      ref={dropdownRef}
      className={tw`absolute z-50 bg-white opacity-80 border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto w-full mt-6 `}
      style={{
        top: inputRef?.current?.offsetTop + inputRef?.current?.offsetHeight || 0,
      }}
    >
      {suggestions.map((contact, index) => (
        <div
          key={contact.id}
          onClick={() => onSelect(contact.email)}
          className={tw`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
            index === selectedIndex ? "bg-gray-100" : ""
          }`}
        >
          <div className={tw`text-sm font-medium text-gray-900`}>
            {contact.name || contact.email}
          </div>
          {contact.name && (
            <div className={tw`text-xs text-gray-500`}>{contact.email}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EmailSuggestions;